class InfoDrawer extends HTMLElement {
    connectedCallback() {
        this.panel = this.querySelector("[data-drawer]")
        this.openBtn = this.querySelector("[data-drawer-open]")
        this.closeBtn = this.querySelector("[data-drawer-close]")
        this.overlay = this.querySelector("[data-drawer-overlay]")

        this.open = this.open.bind(this)
        this.close = this.close.bind(this)
        this.onKeydown = this.onKeydown.bind(this)

        this.openBtn?.addEventListener("click", this.open)
        this.closeBtn?.addEventListener("click", this.close)
        this.overlay?.addEventListener("click", this.close)
        this.overlay?.addEventListener("touchmove", (e) => e.preventDefault(), {
            passive: false,
        })
    }

    disconnectedCallback() {
        document.removeEventListener("keydown", this.onKeydown)
    }

    open() {
        document
            .querySelectorAll("info-drawer.drawer-open")
            .forEach((el) => el !== this && el.close())

        this.classList.add("drawer-open")
        this.openBtn?.setAttribute("aria-expanded", "true")
        document.documentElement.classList.add("overflow-hidden")
        document.addEventListener("keydown", this.onKeydown)
        requestAnimationFrame(() => this.closeBtn?.focus())
    }

    close() {
        this.classList.remove("drawer-open")
        this.openBtn?.setAttribute("aria-expanded", "false")
        document.documentElement.classList.remove("overflow-hidden")
        document.removeEventListener("keydown", this.onKeydown)
        this.openBtn?.focus()
    }

    onKeydown(event) {
        if (event.key === "Escape") this.close()
    }
}

customElements.define("info-drawer", InfoDrawer)
